import { Component } from '@angular/core';

@Component({
  selector: 'app-remind-me-dialog',
  templateUrl: './remind-me-dialog.component.html',
  styleUrls: ['./remind-me-dialog.component.scss']
})
export class RemindMeDialogComponent {
}
